module.exports = __webpack_public_path__ + "img/20190603162321QQ截图20190527164144.f16875d0.png";